import { clsx } from 'clsx';
import { Sparkles } from 'lucide-react';
import { brand } from '@/config/brand';

const configItems = [
  {
    title: 'Document extraction fields',
  },
  {
    title: 'ERP & mailbox integrations',
  },
  {
    title: 'Vendor configuration',
  },
  {
    title: 'Bill creation settings',
  },
];

export const WelcomeStep = () => {
  const companyName = brand.name;
  const logoUrl = brand.logoUrl;
  const showLogo = !!logoUrl;

  return (
    <div className="flex flex-col items-center text-center">
      {/* Logo or fallback icon */}
      <div className="mb-6">
        {showLogo ? (
          <img
            src={logoUrl}
            alt={`${companyName} logo`}
            className="h-16 w-16 object-contain rounded-lg"
          />
        ) : (
          <div
            className={clsx(
              'h-16 w-16 flex items-center justify-center rounded-lg',
              'bg-primary-50 dark:bg-primary-900/20'
            )}
          >
            <Sparkles className="h-8 w-8 text-primary-600 dark:text-primary-400" />
          </div>
        )}
      </div>

      {/* Heading */}
      <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-50">
        {companyName ? `Welcome to ${companyName}!` : 'Welcome!'}
      </h2>

      {/* Configuration items grid */}
      <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4 w-full max-w-lg">
        {configItems.map((item) => (
            <div
              key={item.title}
              className={clsx(
                'flex items-start gap-3 rounded-xl p-4 text-left',
                'bg-gray-50 dark:bg-gray-800/50',
                'border border-gray-200 dark:border-gray-700'
              )}
            >
              {/* Dot indicator */}
              <span
                className={clsx(
                  'mt-1.5 h-2 w-2 flex-shrink-0 rounded-full',
                  'bg-primary-500 dark:bg-primary-400'
                )}
              />
              <div className="min-w-0">
                <p className="text-sm font-medium text-gray-900 dark:text-gray-50">
                  {item.title}
                </p>
              </div>
            </div>
        ))}
      </div>
    </div>
  );
};
